import dateTimeFormatter from 'mrf/utils/DateTimeFormatter';
import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import {useTranslation} from "react-i18next";

export default function CommunicationProcessList({ match }) {

    const {t} = useTranslation();

    const fields = [
        { name: t('Code'), key: 'id' },
        { name: t('Importing Country'), keys: ['importingCountry', 'country', 'name'] },
        { name: t('Exporting Country'), keys: ['exportingCountry', 'country', 'name'] },
        { name: t('Created at'), key: 'recordTimestamp', map: dateTimeFormatter },
        { name: t('Last Update'), key: 'updatedTimestamp', map: dateTimeFormatter },
        { name: 'Status', keys: ['currentProcessStatus', 'name'], map:t },
    ];

    return (
        <ListCRUD
            resource='communicationProcesses'
            fields={fields}
            match={match}
            disableViewButton
            disableNewButton
            disableEditButton
        />
    );
};